import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';
import { UiAvatarComponent } from '@nexus/frontend-shared-ui';
import type { WishlistOverviewRowView } from '../../types/wishlist-overview-row-view.interface';
import { WishlistProgressSummaryComponent } from '../wishlist-progress-summary/wishlist-progress-summary.component';

@Component({
  selector: 'wishlist-row-card',
  imports: [UiAvatarComponent, WishlistProgressSummaryComponent],
  templateUrl: './wishlist-row-card.component.html',
  styleUrl: './wishlist-row-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WishlistRowCardComponent {
  public readonly row: InputSignal<WishlistOverviewRowView> = input.required<WishlistOverviewRowView>();
  public readonly selected: OutputEmitterRef<string> = output<string>();

  protected readonly beneficiaryInitials: Signal<string> = computed((): string => {
    const label: string = this.row().beneficiaryLabel.replace('Dla:', '').trim();

    return label ? label.charAt(0).toUpperCase() : 'W';
  });
  protected readonly hasStatus: Signal<boolean> = computed((): boolean => this.row().statusLabel !== null);

  protected handleSelected(): void {
    this.selected.emit(this.row().id);
  }
}
